import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


/* Global State for  favourites
*  Contains:  
*  - Reducers
*  - Actions

*  - async thunks (api calls)
*/


// //? Async Thunk to fetch favourites from backend\


// export const fetchFavourites = createAsyncThunk(
//  `favourites/loadFavourites`, //! {URL}
//  async (userID, thunkAPI) => {
//      const response = await axios.get('add/URL')  //! {Backend URL}
//      return response.data.favourites;
//  }
// );


//? Initial favourites state  
const initialState = {
    favouritesArray: [],
    loading: false,
    error: null,
};


// ===========================================

//? reducers, action creators / types
const favouritesSlice = createSlice({
    name: 'favourites',
    initialState,

    //? Actions ------------------
    reducers: {

        addFavorite(state, action) {
            // action.payload is the entire property object
            state.favouritesArray.push(action.payload);
        },
        removeFavourite(state, action) {
            // action.payload is the entire property object
            state.favouritesArray = state.favouritesArray.filter(
                (prop) => prop.uuid !== action.payload.uuid
            );
        },


        // Action to load from localStorage

        loadFromStorage(state, action) {
            state.favouritesArray = action.payload;
        },
    },

    // //? --- extra Actions for Thunk (actions for fetch operations) ---

    // extraReducers: (builder) => {
    //     builder
    //         .addCase(fetchFavourites.pending, (state) => {
    //             state.loading = true;
    //             state.error = null;
    //         })

    //         //* On successful fetch from server
    //         .addCase(fetchFavourites.fulfilled, (state, action) => {
    //             state.loading = true;
    //             state.favouritesArray = action.payload;
    //         })

    //         //* On error/reject
    //         .addCase(fetchFavourites.rejected, (state, action) =>{
    //             state.loading = false;
    //             state.error =  action.error.message || 'Failed to load favourites';
    //         });
    // },
});

//? Reducer and actions get exported
export const { addFavorite, removeFavourite } = favouritesSlice.actions;
export default favouritesSlice.reducer;